<template>
    <div class="services-details-area ptb-100 d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image">
                        <img src="../../assets/images/services/periodontology/periodontology_main_page.webp" alt="image">
                    </div>
                    <div class="services-details-content">
                        <u><h3>{{ $t('periodontology_services_title') }}</h3></u>
                        <p>{{ $t('periodontology_p1') }}</p>
                        <p>{{ $t('periodontology_p2') }}</p>
                        <p>{{ $t('periodontology_p3') }}</p>
                        
                    </div>
                   <div class="services-details-content">
                        <p> {{ $t('periodontology_li_p') }}</p>
                        <ol>
                                <li>
                                     {{ $t('periodontology_li_1') }}
                                </li>
                                <li>
                                     {{ $t('periodontology_li_2') }}
                                </li>

                                <li>
                                     {{ $t('periodontology_li_3') }}
                                </li>
                                <li>
                                     {{ $t('periodontology_li_4') }}
                                </li>
                                <li>
                                     {{ $t('periodontology_li_5') }}
                                </li>
                                <li>
                                     {{ $t('periodontology_li_6') }}
                                </li>
                            </ol> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>


    export default {
        name: 'Periodontology',
    };
    
</script>

